import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';

import { TextField } from '@mssgme/ui';
import CardEditForm from '../CardEditForm';

import styles from './PixelEdit.scss';

const PLATFORMS = {
    facebook: {
        label: 'Facebook pixel ID',
        help: 'pixelEdit.help.facebook',
    },
    google: {
        label: 'Google PageAnalytics tracking ID',
        help: 'pixelEdit.help.google',
    },
    yandex: {
        label: 'Yandex Metrika tracking ID',
        help: 'pixelEdit.help.yandex',
    },
};

export default function PixelEdit() {
    const { t } = useTranslation('cards');
    const { platform } = useParams();

    const { help } = useMemo(
        () => ({
            label: get(PLATFORMS, `${platform}.label`, ''),
            help: t(get(PLATFORMS, `${platform}.help`, '')),
        }),
        [platform]
    );

    const pageTitle = platform.charAt(0).toUpperCase() + platform.slice(1);

    return (
        <CardEditForm title={pageTitle} backPath="/p/settings/tracking" successRedirectPath="/p/settings/tracking">
            {() => (
                <>
                    <TextField
                        id="card_pixel"
                        name={`analytics.${platform}`}
                        placeholder={t('pixelEdit.placeholder')}
                    />
                    {help && <div className={styles.help}>{help}</div>}
                </>
            )}
        </CardEditForm>
    );
}
